<template>
<ValidationObserver ref="observer">
  <form ref="add_service_master_form" @submit.prevent="addServiceMaster">
    <md-card>
      <!-- <md-card-header class="md-card-header-icon">
        <div class="card-icon">
          <md-icon>perm_identity</md-icon>
        </div>
        <h4 class="title">
          <span style="color:brown">Add Service Master</span>
        </h4>
      </md-card-header> -->
      <md-card-content>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Service Master Code</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="code" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Service Master Code</label>
                <md-input v-model="service_master_code" required/>
                <validation-error :errors="apiValidationErrors.service_master_code" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Service Category</span><span style="color:red">*</span>
            </label> -->
              <validation-provider rules="category" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Service Category</label>
                <md-select v-model="service_category" required>
                  <md-option v-for="option in options_service_category" :key="option.value" :value="option.id">
                    {{ '('+option.service_category_code+') '+option.service_category_name }}
                  </md-option>
                </md-select>
                <validation-error :errors="apiValidationErrors.service_master_category_id" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
          </div>

        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
          <!-- <label class="md-layout-item md-size-15 md-form-label">
            <span style="color:brown">Service Master Name</span><span style="color:red">*</span>
          </label> -->
              <validation-provider rules="name" v-slot="{ errors }">
              <md-field class="md-invalid">
                <label for="">Service Master Name</label>
                <md-input v-model="service_master_name" required/>
                <validation-error :errors="apiValidationErrors.service_master_name" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
        <div class="md-layout">
          <div class="md-layout-item md-small-size-100">
            <!-- <label class="md-layout-item md-size-15 md-form-label">
              <span style="color:brown">Service Master LTS</span><span style="color:red">*</span>
            </label> -->
              <validation-provider rules="lts" v-slot="{ errors }">
              <md-field class="md-invalid">
              <label for="">Service Master LTS</label>
                <md-input v-model="service_master_lts" type="text" v-on:keypress="NumbersOnly" required/>
                <validation-error :errors="apiValidationErrors.service_master_lts" />
                <span class="md-error">{{ errors[0] }}</span>
              </md-field>
              </validation-provider>
            </div>
        </div>
      </md-card-content>
      <br>
      <md-card-actions>
        <md-button class="md-info md-dense" @click="addConfirmation">
          Submit
        </md-button>
        <md-button class="md-dense"  @click="backtoList">
          Go to List
        </md-button>
      </md-card-actions>
    </md-card>

  </form>
</ValidationObserver>
</template>

<script>
import {ValidationError} from "@/components";
import { extend, ValidationObserver } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import formMixin from "@/mixins/form-mixin";
import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2';
import Swal from 'sweetalert2';

Vue.use(VueSweetalert2);
// validasi pesan error required field
extend('name', {
  ...required,
  message: 'Service Master Name field is required'
});
extend('code', {
  ...required,
  message: 'Service Master Code field is required'
});
extend('category', {
  ...required,
  message: 'Service Master Category field is required'
});
extend('lts', {
  ...required,
  message: 'Service Master Lts field is required'
});
export default {
  name: "add-service-master",

  props: {
    data: Object
  },

  components: {ValidationError, ValidationObserver},

  mixins: [formMixin],

  data: () => ({
    service_master_code: null,
    service_category: null,
    service_master_name: null,
    service_master_lts: null,
    options_service_category: null,
  }),

  created() {
    this.onOpen();
  },
  methods: {
    // fungsi tombol direct ke list view table
    backtoList(id) {
      this.$router.replace({ name: 'List Service Master', params: { id: id } })
    },

    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
      
    async onOpen(){
      await this.$store.dispatch("workshop_service_categories/list")
      this.options_service_category = await this.$store.getters["workshop_service_categories/list"]
    },
    
    // validasi untuk add data
    async addConfirmation() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return
      }
      Swal.fire({
        title: 'Are you sure?',
        text: 'The data will Saved!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, saved it!',
        cancelButtonText: 'No, cancel!',
        buttonsStyling: true
      }).then((result) => {
        if (result.value){
          this.addServiceMaster()
        }
      });
    },

    // fungsi add data
    async addServiceMaster() {
      const data = {
        type: "workshop_service_masters",
        service_master_code: this.service_master_code,
        service_master_category_id: this.service_category,
        service_master_name: this.service_master_name,
        service_master_lts: this.service_master_lts
      }
      try {
        // kirim data ke api
        await this.$store.dispatch("workshop_service_master/add", data);
        // panggil alert success
        await this.$store.dispatch(
          "alerts/success",
          "Successfully registered."
        );
        // kembali ke list service master
        await this.$router.push({name: 'List Service Master'});
      } catch (e) {
        // panggil alert error
        await this.$store.dispatch(
        "alerts/error",
        "Oops, something went wrong"
        );
        console.log(e.response.data.errors);
        this.setApiValidation(e.response.data.errors);
      }

    }
  }
};
</script>
<style scoped>
.md-layout-item{
  margin-top:10px;
}
</style>
